import React from 'react';

export const LaunchDarklyContext = React.createContext(null);
export const UserContext = React.createContext(null);
